import { useMemo } from 'react'

import { useQueryResult, useWindow } from '@krp/client-runtime'
import {
  CashShiftsScreen,
  cashShiftsArgsOf,
  cashShiftsCashierChanged,
  cashShiftsDayChanged,
  cashShiftsMonthChanged,
  cashShiftsNodeChosen,
  cashShiftsScreenVmOf,
  cashShiftsStateChanged,
  cashShiftsTreeToggled,
  cashShiftsViewOf,
  normalizeRid,
  onecCashRegisters,
  onecCashShifts,
  reloadCashReceipts,
  type CashShiftsScreenActions,
} from '@krp/resource-onec-ui'

import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { localToday } from './supplyDates'

/**
 * Binding окна «Смены 1С» (раздел «Смены»): rid — из окна (D-064). Два чтения службы 1С: кассы с деревом мест и смены показанного
 * месяца по всей базе; место, день, кассир и состояние отбирает экран. Месяц по умолчанию — текущий по часам человека.
 */
export function CashShiftsBinding() {
  const window = useWindow()
  const dispatch = useAppDispatch()
  const resourceId = normalizeRid(window.params.rid ?? '')
  const intent = useAppSelector((state) => state.onec.shifts)
  const view = cashShiftsViewOf(intent, resourceId)
  const today = localToday()

  const registersArgs = useMemo(() => (resourceId === '' ? null : { resourceId }), [resourceId])
  const registers = useQueryResult(onecCashRegisters, registersArgs)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const shiftsArgs = useMemo(() => cashShiftsArgsOf(resourceId, view, today), [resourceId, view.month, today])
  const shifts = useQueryResult(onecCashShifts, shiftsArgs)

  const vm = useMemo(
    () => cashShiftsScreenVmOf({ resourceId, today, intent, registers, shifts }),
    [resourceId, today, intent, registers, shifts],
  )

  const actions = useMemo<CashShiftsScreenActions>(
    () => ({
      nodeChosen: (nodeId) => dispatch(cashShiftsNodeChosen({ resourceId, nodeId })),
      nodeToggled: (nodeId) => dispatch(cashShiftsTreeToggled({ resourceId, nodeId })),
      monthChanged: (month) => dispatch(cashShiftsMonthChanged({ resourceId, month })),
      dayChanged: (day) => dispatch(cashShiftsDayChanged({ resourceId, day })),
      cashierChanged: (cashier) => dispatch(cashShiftsCashierChanged({ resourceId, cashier })),
      stateChanged: (state) => dispatch(cashShiftsStateChanged({ resourceId, state })),
      refresh: () => dispatch(reloadCashReceipts(resourceId)),
      retry: () => dispatch(reloadCashReceipts(resourceId)),
    }),
    [dispatch, resourceId],
  )

  return <CashShiftsScreen vm={vm} actions={actions} />
}
